import React from 'react'
import { cssTransition } from 'react-toastify'
import * as SC from './ToastContainerStyles'
import { LAYER_Z_INDEXES } from '../../styles/constants'

const ToastAnimation = cssTransition({
	enter: 'enter-animation',
	exit: 'exit-animation',
	appendPosition: false,
	collapse: true,
	collapseDuration: 300
})

const ToastContainer = () => {
	return (
		<SC.StyledToastContainer
			transition={ToastAnimation}
			hideProgressBar
			closeButton={false}
			// Inline values win over react-toastify's runtime-injected position and z-index.
			style={{
				position: 'fixed',
				zIndex: LAYER_Z_INDEXES.NOTIFICATION
			}}
		/>
	)
}

export default ToastContainer
